import apiClient from '../apiClient';
import { DELETE_CONTRACTING_FILE_URL } from '../apiUrl';

const deleteContactingFileApi = (fileId, ProfileId) => {
  return apiClient.delete(DELETE_CONTRACTING_FILE_URL(fileId, ProfileId));
};

export default deleteContactingFileApi;
